/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import './styles.scss';

const SubscriptionStatus = ({ status }) => {
    
    const renderLabel = (status) => {
        switch (status) {
            case 'non_renewing':
                return 'non renewing';
            default:
                return status;
        }
    };

    const classes = classNames('subscription-status', "subscription-status--" + status);

    return (
        <div className={classes}>
            <span>{renderLabel(status)}</span>
        </div>
    );

};

SubscriptionStatus.defaultProps = {};
SubscriptionStatus.propTypes = {};

export default SubscriptionStatus;
